import * as React from "react";
const SvgIconArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 63.6 113.2", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "7.1 0 0 7.1 49.5 56.6 0 106.1 7.1 113.2 56.6 63.7 56.6 63.7 63.6 56.6 56.6 49.5 56.6 49.5 7.1 0" }));
export default SvgIconArrowRight;
